import { useEffect } from 'react';
import {
    FacebookShareButton,
    FacebookIcon,
} from 'next-share';

export const FacebookShareTemplate = ({ pageUrl, pageTitle }) => {
    useEffect(() => {
        // Add `rel="nofollow"` to the first anchor tag in this component
        const shareLinks = document.querySelectorAll('.facebook-share-button button');
        shareLinks.forEach((link) => {
            link.setAttribute('rel', 'nofollow');
        });
    }, []);

    return (
        <div className="facebook-share-button">
            <FacebookShareButton url={pageUrl} quote={pageTitle}>
                <FacebookIcon size={44} round />
            </FacebookShareButton>
        </div>
    );
};
